// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import './theme/element/index.css'  //自定义主题样式文件
import './assets/css/common.css'  //单独引入通用样式文件
import './assets/css/soft-ui.css'  //自然极简风格样式文件
import cookie from "./service/cookie";
import config from './config'  // 引入运行时配置管理模块
Vue.use(Element)

Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$http = axios
// 引入自定义过滤器
import tableFilters from './commonJs/Filters'
// 这种方式可以将filters.js中的所有过滤器都注册
for (let key in tableFilters) {
  Vue.filter(key, tableFilters[key])
}

// 引入重新定义的$message
import {message} from './commonJs/ResetMessage'
Vue.prototype.$message = message;

// 使用vue-cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);


const VUE_APP_VERSION = 'v2.8.1';
const vers = localStorage.getItem('28projectVersion');

// 版本检测：仅当存在旧版本号且与当前版本不一致时才清理登录态并跳登录页；
// 首次打开（vers 为 null）只写入版本号，不清理。版本号存 localStorage（不受 WebView 回收 cookie 影响，且不过期更合理）。
if (vers && VUE_APP_VERSION !== vers) {
  cookie.removeCookie('28project_usertoken');//token authorization
  cookie.removeCookie('28project_refreshToken');//用来刷新authorization
  localStorage.removeItem('28project_usertoken');
  localStorage.removeItem('28project_refreshToken');
  localStorage.setItem('28projectVersion', VUE_APP_VERSION);

  // 移动端跳 /m/login，PC 跳 /login
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const isMobileDevice = mobileRegex.test(navigator.userAgent || '') || (window.innerWidth || 0) <= 520;
  location.href = isMobileDevice ? '/m/login' : '/login';
} else {
  localStorage.setItem('28projectVersion', VUE_APP_VERSION);
}

// 预加载配置
config.getConfig().then((cfg) => {
  console.log('配置加载成功');

  // 动态加载umami统计，根据ENV字段选择配置
  const env = cfg.ENV || 'test';
  const umamiConfigs = {
    test: {
      url: 'http://192.168.1.88:3000',
      id: 'd3777e29-9cac-43f9-a748-4d5d122b74ee'
    },
    blue: {
      url: 'http://192.168.1.88:3000',
      id: 'b6fb1246-e8de-46a2-9aab-feac872bed36'
    },
    production: {
      url: 'http://tongji.365ecg.xyz',
      id: '315575ce-161c-425d-a937-0ba3ef459b2b'
    }
  };

  const umamiConfig = umamiConfigs[env] || umamiConfigs.test;
  if (umamiConfig && umamiConfig.url && umamiConfig.id) {
    const script = document.createElement('script');
    script.defer = true;
    script.src = `${umamiConfig.url}/script.js`;
    script.setAttribute('data-website-id', umamiConfig.id);
    document.head.appendChild(script);
    console.log('Umami统计已加载:', env, umamiConfig.url, umamiConfig.id);
  }

  // 根据环境更新下载工具URL
  if(env == 'production'){
    localStorage.setItem('exeDownLoadUrl','https://etcomm-release.oss-cn-zhangjiakou.aliyuncs.com/pdfdownloader/ytkInsuranceProManagerInstall.exe');
    localStorage.setItem('exeDownLoadUrlWin8','https://etcomm-release.oss-cn-zhangjiakou.aliyuncs.com/pdfdownloader/ytkInsuranceProManagerInstallWin8.exe');
  }else{
    localStorage.setItem('exeDownLoadUrl','https://etcomm-release.oss-cn-zhangjiakou.aliyuncs.com/pdfdownloader/ytkInsuranceProManagerInstall_test.exe');
    localStorage.setItem('exeDownLoadUrlWin8','https://etcomm-release.oss-cn-zhangjiakou.aliyuncs.com/pdfdownloader/ytkInsuranceProManagerInstallWin8_test.exe');
  }

  // 触发自定义事件通知组件更新
  window.dispatchEvent(new Event('configLoaded'));

}).catch(error => {
  console.error('预加载配置失败:', error);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js